import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from '@react-pdf/renderer';
import moment from 'moment';
import { useEffect } from 'react';
import Html from 'react-pdf-html';

interface Props {
  userInfo: any;
  setProtocolId: any;
  protocolId: any;
}
// Create styles
const styles = StyleSheet.create({
  page: {
    margin: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0,
    paddingLeft: 20,
    paddingRight: 20,
  },
  nextLine: {
    marginTop: -10,
    marginLeft: 10,
    paddingLeft: 30,
    paddingRight: 30,
    fontSize: '14px',
  },
});

export const ThanksLetterPDF = (props: Props) => {
  const { userInfo, setProtocolId, protocolId } = props;


  const html = `  
  <html>    
    <body>
        <style>        

        .print-container{
          padding: 0px 30px;
          font-size: 12px;
        }


        table {
          margin: 0px 0px;
          padding: 0px;
          border: 1px solid black;
          font-size: 12px;
        }

        table > tbody> tr > *{
          padding: 5px
        }

        table th {
          text-align: center;    
        }
        
        table td {
                
        }

        .bgColor {
          background-color: powderblue;
        }
        b {
          font-family: 'Times-Bold'; 
        }
        p {
          font-size: 14px
        }

        span {
          font-size: 14px;
        }

        .tableMargin {
          margin-top: 5px;
          margin-bottom: 5px;
        }
       
        .signature-box {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: 10px;
          font-family: 'Times-Bold';
        }

        .header-section {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 10px;
        }
      </style>

      <div class="print-container">
        <div class="header-section"> 
          <div>
            <div>
              No. BCPS-Protocol/${moment(new Date()).format('YYYY')}
            </div>
            <div>
              Date: ${moment(new Date()).format('DD MMMM YYYY')}
            </div>
            <div>
              PSN:....................
            </div>
          </div>
        </div>
        

        <div style="margin-top: 10px;">
          <div>To,</div>
          <div>${userInfo?.guide?.personal_info?.full_name}</div>
          <div>${userInfo?.guide?.current_employment_info?.institute_name}, ${userInfo?.guide?.current_employment_info?.working_address}</div>
        </div>

        <div style="margin-top: 10px; margin-bottom: 10px;">
          <b>Subject: Congatulations as a Guide for FCPS ${userInfo?.subject?.subject_name} Dissertation/Thesis</b>
        </div>

        <div style="margin-top: 10px; margin-bottom: 10px;">
          <span>Dear Sir,</span>
          <p>
            It is my great pleasure that I extend sincere congatulations to you as a Guide for the FCPS ${userInfo?.subject?.subject_name} Disseratation/Thesis by the Bangladesh College of Physicians and Surgeons (BCPS). 
          </p>
          <p>
            <b>Name of examinee: ${userInfo?.registration?.personal_info?.full_name}</b>
          </p>
          <p><b>Title: ${userInfo?.title_of_thesis}</b></p>

          <p>
            This prestigious responsibility is a testament to your schorlay competence, professional integrity, and continued contribution to postgraduate medical education.
          </p>

          <p>
            I sincerely appreciate your continuous support in all your academic and professional endeavors.
          </p>
        </div>
        

        <div>
          Sincerely,
        </div>
        <div class="signature-box">
          <div>Professor MD. Nur Hossain Bhuiyan</div>
          <div>Honorary Director (RTM)</div>
          <div>RTMD, BCPS</div>
        </div>
      </div>
    </body>
  </html>
`;


  const MyDocument = (
    <Document>
      <Page size="A4">
        <View style={styles.row} wrap={true}>
          <Text
            style={{
              textAlign: 'center',
              fontFamily: 'Times-Bold',
              fontSize: '22px',
              marginTop: '25px',
              marginBottom: '0px',
              marginLeft: '20px',
            }}
          >
            Bangladesh College of Physicians and Surgeons
          </Text>
          <Image
            src="/images/apple-icon-180x180.png"
            style={{
              width: '40px',
              marginTop: '25px',
              marginBottom: '0px',
              marginLeft: '40px',
            }}
          />
        </View>
        <Text style={styles.nextLine}>
          67, Shaheed Tajuddin Ahmed Sarani, Mohakhali, Dhaka-1212
        </Text>

        <Html>{html}</Html>
      </Page>
    </Document>
  );

  useEffect(() => {
    if (protocolId) {
      const pdfData = pdf(MyDocument).toBlob();
      pdfData.then((pdfData) => {
        const pdfContent = new Blob([pdfData], { type: 'application/pdf' });
        const url = URL.createObjectURL(pdfContent);
        setProtocolId('');
        window.open(url, '_blank');
      });
    }
  }, [protocolId]);

  return (
    <div>

    </div>
  );
};
